// removed by extract-text-webpack-plugin
module.exports = {"text-header-container":"TextHeader__text-header-container___27rml","h1":"TextHeader__h1___2lL8k","h2":"TextHeader__h2___3YzPH"};